module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAXCAYAAABnGz2mAAAAAXNSR0IArs4c6QAAAGdJREFUSA1jPKtp959hEAKmQegmsJNGHUZqzIyG2LAJMcY367YNyuKC8T8QkBrM9FA/mvhJDeXREBsNMVJDgFT1jFk9RYOyuGC59fgOqZ6hi/rRXElqMI+G2LAJMRZ5CbmvpPqGHuoB0PQP92tFhfcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hungary.png
// module id = 473
// module chunks = 7